module.exports = "https://cdn.redage.net/src/views/player/help/images/gazon2.jpg";